/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { getStatus } from 'helpers/status-badge';
import StatusBadge from 'components/custom/ui/StatusBadge';
import { Icon } from '@iconify/react';

const vehicleTypeListColumns = [
  {
    accessorKey: 'vehicle_name',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <Icon
              icon="mdi:graph-outline"
              fontSize={16}
              className="text-primary-600 dark__text-primary-300"
            />
          </div>
          <span>Vehicle Type</span>
        </div>
      );
    },
    meta: {
      headerProps: { className: 'ps-0' },
      cellProps: { className: 'white-space-nowrap ps-0 text-primary' }
    }
  },
  {
    accessorKey: 'status',
    header: 'status',
    cell: ({ row: { original } }) => (
      <StatusBadge
        status={original.status}
        getStatus={getStatus}
        lastComment={original.last_comment}
        flag={original.change_flag}
      />
    )
  }
];

export default vehicleTypeListColumns;
